import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const xps = {
    jpath: ['spectra', 'xps'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default xps;
//# sourceMappingURL=xps.js.map